import { emptyError } from "../../Types/ServicesType/servicesType";
import api from "@services/apiList";
import instance from "@services/services";
const {reportsApi}=api
export const appointmentListService = async (data:any): Promise<any> => {
    try {
        const result=await instance.post(reportsApi.appointmentReportSearch,data)
        return result.data
    } catch (error) {
        return emptyError
    }
}

export const appointmentListReportServiceQa = async (data:any): Promise<any> => {
    try {
        const result=await instance.post(reportsApi.departmentWiseAppointmentListReport,data)
        return result.data
    } catch (error) {
        return emptyError
    }
}
export const appointmentlistpdfService = async (data:any): Promise<any> => {
    try {
        const result=await instance.post(reportsApi.appointmentReportSearchpdf,data)
        return result.data
    } catch (error) {
        return emptyError
    }
}
export const appointmentlistpdfServiceDepartmentWise = async (data:any): Promise<any> => {
    try {
        const result=await instance.post(reportsApi.appointmentListReportServiceDepartmentwiseFilteringpdf,data)
        return result.data
    } catch (error) {
        return emptyError
    }
}

export const appointmentlistexcelService = async (data:any): Promise<any> => {
    try {
        const result=await instance.post(reportsApi.appointmentListReportServiceDepartmentwiseFilteringExcel,data)
        return result.data
    } catch (error) {
        return emptyError
    }
}



